<style lang="scss">
.orderlog-title{
    line-height: 36px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 16px;
    padding-left: 20px;
    background-color: #808695;
    color: #fff;
}
</style>

<template>
    <div>
        <div class="bg-fff margin-top-20 padding-bottom-20" >
            <header class="orderlog-title font-bold">订单日志</header>
            <Table
            class="margin-10"
            :columns="columns" 
            :data="formList"
            size="small" 
            ref="table"  
            border 
            stripe></Table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: ['comOrderlog', 'type', 'status', 'parentId'],
    data() {
        return {
            
        }
    },
    created() {

    },
    computed:{
        formList(){
            return this.comOrderlog || []
        },
        columns() {
            return [{
                title: '日期',
                key: 'createdAt',
                render(h, { row }) {
                    return <div>
                    {row.createdAt}
                    </div>
                }
            }, {
                title: '订单日志',
                key: 'message',
                render(h, { row }) {
                    return <div>
                    {row.message}
                    </div>
                }
            }, {
                title: '用户',
                key: 'opUserName',
                render(h, { row }) {
                    return <div>{row.opUserName}</div>
                }
            }, 
            // {
            //     title: '操作',
            //     key: 'opUserId',
            //     render(h, { row }) {
            //         return <div>--</div>
            //     }
            // }
            ]
        },
    },
    methods: {

    },

}
</script>

